import {createImageObject} from '../utils';

export default {
    namespaced: true,
    state: {
      title: '智能抠图',
      uploadImg: [],
      displayImg: [],
      recordImg: [],
      editLoading: false,
      toolBarLoading: false,
      suggestImg: [{
        url: 'https://feed-image.baidu.com/0/pic/726461624_-2085978454_-230167233.jpg',
        specialOrgUrl: 'https://feed-image.baidu.com/0/pic/726461624_-2085978454_-230167233.jpg',
        prompt: '电器',
        width: '2048',
        height: '1365'
      }, {
        url: 'https://feed-image.baidu.com/0/pic/-1996252100_-898953353_1730827894.jpg',
        specialOrgUrl: 'https://feed-image.baidu.com/0/pic/-1996252100_-898953353_1730827894.jpg',
        prompt: '猫',
        width: '2048',
        height: '1365'
      }, {
        url: 'https://feed-image.baidu.com/0/pic/765920586_-2093550076_-1290966808.jpg',
        specialOrgUrl: 'https://feed-image.baidu.com/0/pic/765920586_-2093550076_-1290966808.jpg',
        prompt: '杯子',
        width: '2048',
        height: '1365'
      }],
      placeHolder: {
        page: 'cutout',
        title: '',
        subtitle: '',
        src: 'https://qiaojiang.bj.bcebos.com/fe/static/Demo_ImageMatting_Command_4x.mp4'
      },
      historyParams: {
        pageNo: 1,
        pageSize: 10,
        taskType: [12]
      },
      pageLoadingStatus: {
        show: false,
        title: ''
      }
    },
    mutations: {
        CHANGE_UPLOAD_IMG(state, data) {
            state.uploadImg = data;
        },
        CHANGE_RECORD_IMG(state, data) {
            state.recordImg = data;
        },
        CHANGE_DISPLAY_IMG(state, data) {
            state.displayImg = data;
        },
        CHANGE_EDIT_LOADING(state, data) {
            state.editLoading = data;
        },
        CHANGE_TOOLBAR_LOADING(state, data) {
            state.toolBarLoading = data;
        },
        CHANGE_PAGE_STATUS(state, data) {
            state.pageLoadingStatus = data;
        }
    },
    actions: {
        changeUploadImg({commit}, data) {
            commit('CHANGE_UPLOAD_IMG', data);
        },
        changeDisplayImg({commit}, data) {
            commit('CHANGE_DISPLAY_IMG', data);
        },
        changePageStatus({commit}, data) {
            commit('CHANGE_PAGE_STATUS', data);
        },
        // 获取创作纪录
        async getHistory({commit, state}, model) {
            try {
                const res = await model.imageCreate.getHistory(state.historyParams);
                const recordImgList = res.listData.map(i => {
                    const recordList = i.records;
                    return recordList;
                }).filter(item => item !== undefined);

                commit('CHANGE_RECORD_IMG', recordImgList);
            }
            catch (err) {
                throw err;
            }
        },
        // 图片上传 获取主体
        async handleImagePickerConfirm({commit, state}, info) {
            const {res} = info;
            const imgRes = res?.data?.[0]?.[0] || [];
            const uploadImg = imgRes.map(item => ({
                url: item.url,
                prompt: '',
                width: item.width,
                height: item.height
            }));
            const allUploadImg = state.uploadImg.concat(uploadImg);
            commit('CHANGE_UPLOAD_IMG', allUploadImg);
            // commit('CHANGE_EDIT_LOADING', true);

            // try {
            //     const needAskList = allUploadImg.filter(item => !item.prompt);
            //     const uploadImgData = await model.imageCreate.queryImageSubjectDesc({
            //         imageUrls: needAskList.map(item => item.url)
            //     });
            //     const updatedUploadImgData = uploadImgData.map((item, i) => ({
            //         ...item,
            //         width: needAskList[i].width,
            //         height: needAskList[i].height
            //     }));
            //     const baseUploadImg = state.uploadImg.filter(i => i.prompt !== '');
            //     commit('CHANGE_UPLOAD_IMG', baseUploadImg.concat(updatedUploadImgData));
            // }
            // catch (err) {
            //     console.error(err);
            //     throw err;
            // }
            // finally {
            //     commit('CHANGE_EDIT_LOADING', false);
            // }
        },
        // 抠图按钮提交
        async handleCutSubmit({commit, state}, model) {
            commit('CHANGE_TOOLBAR_LOADING', true);
            try {
                const baseDisplayImg = state.uploadImg.map((_, index) => createImageObject({recordId: index}));
                commit('CHANGE_DISPLAY_IMG', baseDisplayImg);

                const params = state.uploadImg.map(i => ({
                    cropMain: 1,
                    prompt: i.prompt,
                    subjectImage: i.url,
                    width: `${i.width}`,
                    height: `${i.height}`
                }));
                const data = await model.imageCreate.cutoutImageV2({
                    cutItem: params,
                    saveType: true,
                    hasParam: false
                });
                const displayImg = data.map(i => createImageObject({
                    specialOrgUrl: i.specialOrgUrl,
                    url: i.subjectImage,
                    taskId: i.taskId,
                    recordId: i.recordId,
                    width: i.width,
                    height: i.height,
                    ext: i.ext
                }));

                commit('CHANGE_DISPLAY_IMG', displayImg);
            }
            catch (err) {
                console.error(err.message);
                throw err;
            }
            finally {
                commit('CHANGE_TOOLBAR_LOADING', false);
            }
        }
    },
    getters: {
    }
  };
